export const RoutesPath = {
  DASHBOARD: "/dashboard",
  CREATECONTACT: "/list/createlist",
  CAMPAIGNHISTORY: "/smscampaign",
  CAMPAIGNHISTORYDETAILS: "/smscampaign/history",
  SMSCAMPAIGN: "/smscampaign/createsms",
  LISTDETAILS: "/list/listdetails",
  LOGIN: "/login",
  INITIAL_PAGE: "/",
  CONTACT: "/contact",
  LIST: "/list",
  BLANK: "/blank",
};
